// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"product-list_categoryList__11JHv","showMore":"product-list_showMore__1llDE"};